import React from 'react'

import Lottie from 'lottie-react'
import * as Load from '../../assets/lottie/loading.json'

export default function Loading({ isLoading, setIsLoading }) {
  return (
    <>
      {isLoading && (
        <div className='sg-absolute sg-w-screen sg-h-screen sg-flex sg-flex-col sg-justify-center sg-items-center sg-bg-[#8e8e96c5] sg-z-[999999]'>
          <Lottie
            animationData={JSON.parse(JSON.stringify(Load))}
            className='sg-w-[50px] sg-h-[50px]'
            speed={1}
            loop={true}
            autoPlay={true}
          />
        </div>
      )}
    </>
  )
}
